export default {
  SAVE_VIEW_HOME_WORK(state,viewHomeWorks){
    state.viewHomeWorks.push(viewHomeWorks)
  }
}



// WEBPACK FOOTER //
// ./src/store/axj_help/mutaions.js